/**
 * Get and normalize the backend API URL
 * Removes trailing slashes and ensures consistent formatting
 */
export function getBackendUrl(): string {
  const url = import.meta.env.VITE_API_BASE_URL || "https://api.regulagent.app"
  // Remove trailing slash if present
  const normalized = url.replace(/\/$/, "")
  console.log("[RegulAgent] API Base URL configured as:", normalized)
  return normalized
}

export const API_BASE_URL = getBackendUrl()
